const block_icons     = {
    flat_icon:     <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 612 612"
  >
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#e11616"
        d="M63.311 73.862C28.342 73.862 0 102.204 0 137.172s28.342 63.311 63.311 63.311c34.968 0 63.31-28.342 63.31-63.311s-28.342-63.31-63.31-63.31zm0 168.827C28.342 242.689 0 271.032 0 306c0 34.969 28.342 63.311 63.311 63.311 34.968 0 63.31-28.342 63.31-63.311 0-34.968-28.342-63.311-63.31-63.311zm0 168.829C28.342 411.518 0 439.859 0 474.827c0 34.969 28.342 63.311 63.311 63.311 34.968 0 63.31-28.342 63.31-63.311 0-34.968-28.342-63.309-63.31-63.309zm168.827-232.139h337.655c23.319 0 42.207-18.888 42.207-42.207s-18.888-42.207-42.207-42.207H232.138c-23.319 0-42.207 18.888-42.207 42.207s18.888 42.207 42.207 42.207zm337.655 84.414H232.138c-23.319 0-42.207 18.888-42.207 42.207s18.888 42.207 42.207 42.207h337.655C593.112 348.207 612 329.319 612 306s-18.888-42.207-42.207-42.207zm0 168.828H232.138c-23.319 0-42.207 18.887-42.207 42.206s18.888 42.207 42.207 42.207h337.655c23.319 0 42.207-18.888 42.207-42.207s-18.888-42.206-42.207-42.206z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}

export default block_icons;